import FlowGrid from '@/components/FlowGrid/index.vue';
import Banner from '@/components/Banner2';
import Cases from '@/components/Cases/index.vue';
import SmartCard from '@/components/SmartCard';
import SmartTitle from '@/components/SmartTitle';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    FlowGrid,
    Banner,
    Cases,
    SmartCard,
    SmartTitle,
    Appointment2
  },
  data() {
    return {
      bannerUrl: require('@/assets/images/service/callqualityinspection/callQualityInspection-banner.png'),
      cooperationList: [{
        title: '实时处理:',
        desc: '实时接入客服录音，无需后期导入录音'
      }, {
        title: '客服全覆盖:',
        desc: '覆盖100%客服，目标明确，重点清晰.'
      }, {
        title: '多维度质检:',
        desc: '内容质检、效率质检、质量质检.'
      }, {
        title: '智能统计:',
        desc: '自动质检流程任务分配、实时报表统计'
      }, {
        title: '智能工作台: ',
        desc: '高效听音、看文本、智能复核、打分表'
      }],
      chooes: [{
        title: '服务内容',
        desc: ['不该说的内容', '业务解答', '流程规范'],
        icon: require('@/assets/images/service/callqualityinspection/label.png')
      }, {
        desc: ['接通响应速度', '通话中响应速度', '客户等待时长'],
        title: '服务效率',
        icon: require('@/assets/images/service/callqualityinspection/rocket.png')
      }, {
        desc: ['语速过快', '客服抢话', '负面情绪'],
        title: '服务质量',
        icon: require('@/assets/images/service/callqualityinspection/quality.png')
      }],
      efficientList: [{
        title: '',
        desc: '支持客服纬度、客户纬度、任务纬度、规则纬度统计'
      }, {
        title: '',
        desc: '支持人机质检对比'
      }, {
        title: '',
        desc: '支持配置自定义报表，交叉数据分析掌控质检动态'
      }],
      inspectionList: [{
        title: '文本转写',
        desc: '借助语音处理平台，对客服对话语音进行文本转写'
      }, {
        title: '语音对照测听',
        desc: '语音和文本进度自动关联，支持对转写的文本和语音进行对照测听'
      }, {
        title: '自定义打分表',
        desc: '质检人员可以根据自己的打分标准建立复核分数机制'
      }, {
        title: '计分方式灵活',
        desc: '支持累加型、唯一值、手动型等多种计分方式，可支持不同场景的计分需求'
      }],
      // 中间数据
      skills: [{
        items: [{
          title: '会话接入',
          desc: '多种系统对接方式、实时获取会话质检'
        }, {
          title: '机器质检',
          desc: '检测规则配置、评分规则配置、动态检测'
        }, {
          title: '任务分配',
          desc: '质检员技能配置、机器自动分配任务'
        }]
      }, {
        items: [{
          title: '人工复核',
          desc: '快速定位违规点、转写文本同步展示、快速复核评分'
        }, {
          title: '客服申诉',
          desc: '违规会话推送、客服申诉管理、组长二次复检'
        }]
      }, {
        items: [{
          title: '报表统计',
          desc: '多维度图形化统计、扣分详情查看、打分表导出'
        }]
      }]
    };
  }
};